<template>
    <div>
          <div class="ix-table-box">
                <table class="ix-table ix-table-sm"> 
                    <thead>
                        <tr>
                            <th class="text-left">Numéro</th>
                            <th class="text-left">Désignation</th>
                            <th class="text-left">Etude</th>
                            <th class="text-left">Affaire</th>
                            <th class="text-right">Total HT</th>
                            <th class="text-right">Total TTC</th>
                            <th class="text-right"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(quote, index) in allQuotes" :key="index">
                            <td class="text-left">
                                <a :href="quote.id" target="_blank">
                                    {{ quote.number }}
                                </a>
                                <span class="ix-badge blue ml-1" v-if="quote.id == currentQuoteId">Ce devis</span>
                            </td>
                            <td class="text-left">
                                {{ quote.designation }}
                            </td>
                            <td class="text-left">
                                <span v-if="quote.study">
                                    {{ quote.study.number }}
                                </span>
                            </td>
                            <td class="text-left">
                                <span v-if="quote.deal">
                                    {{ quote.deal.number }} - {{ quote.deal.name }}
                                </span>
                            </td>
                            <td class="text-right">
                                {{ currency(totalHtWithOptions(quote)) }}
                            </td>
                            <td class="text-right">
                               {{ currency(totalTtcWithOptions(quote)) }} 
                               <small class="d-block ix-text-secondary" v-if="parseFloat(quote.total_optional_ttc) > 0">dont {{ currency(quote.total_optional_ttc) }} d'options</small>
                            </td>
                            <td class="text-right">
                                <div class="custom-control custom-switch mt-2">
                                    <input type="checkbox" class="custom-control-input" :id="'quotes['+ quote.id +'][accept]'" :name="'quotes['+ quote.id +'][accept]'" v-model="quote.accepted" @change="handleCheckboxChange(quote)" :checked="!quote.accepted">
                                    <label class="custom-control-label" :for="'quotes['+ quote.id +'][accept]'">Accepter</label>
                                </div>
                            </td>
                        </tr>
                            
                    </tbody>
                </table>
          </div>
           <div class="row mt-4">
            <div class="col-sm-12 text-right">
                <button type="button" class="ix-btn ix-btn-state" @click="openModal">Enregistrer</button>
            </div>
        </div>


          <div class="modal fade" id="acceptQuoteVersionningsModal" tabindex="-1" aria-labelledby="acceptQuoteVersionningsModal" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content text-left">
                        <div class="modal-header">
                            <h5 class="modal-title">Acceptation du devis versionné</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <h3 class="ix-page-title-secondary">Bon de commande client</h3>
                            <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label for="order_ref">Référence</label>
                                            <input type="text" class="form-control" name="order[reference]" id="order_ref" v-model="form.reference">
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label for="order_file">Bon de commande</label>
                                            <input type="file" class="form-control" name="order[file]" id="order_file" v-on:change="onFileChange">
                                            <span class="ix-text-secondary ix-text-small">Taille fichier maximale : 10 Mo</span>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label for="created_at">Date de commande</label>
                                            <div class="ix-datepicker-wrapper">
                                                <input type="text" class="form-control datepicker" name="order[created_at]" id="order_created_at" v-model="form.created_at">
                                            </div>
                                        </div>
                                    </div>

                                     <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label for="order_expected_at">Date de livraison</label>
                                            <div class="ix-datepicker-wrapper">
                                                <input type="text" class="form-control datepicker" name="order[expected_at]" id="order_expected_at" v-model="form.expected_at">
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <br>

                            <div class="row" v-show="selectedQuote && !selectedQuote.deal">
                                <div class="col-sm-12">
                                <h3 class="ix-page-title-secondary">Confirmer l'affectation à une affaire</h3>
                                <div class="alert alert-warning">Il ne sera plus possible de modifier l'affaire associée par la suite</div>

                                </div>
                                 <div class="col-sm-12">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="create_new_deal" id="create_new_deal_false" value="0" :checked="selectedQuote && selectedQuote.deal && form.create_new_deal == 0" v-model="form.create_new_deal">
                                        <label class="form-check-label" for="create_new_deal_false">Affecter à</label>
                                    </div>
                                    <div class="form-group">
                                         <input type="text" class="form-control model-autocomplete" id="deal_label" name="deal[label]" :value="selectedQuote && selectedQuote.deal ? selectedQuote.deal.number + '-' + selectedQuote.deal.name : null"
                                            data-force-value="true"
                                            :data-api-url="this.dealUrl"
                                            data-label="designation"
                                            data-value="designation"
                                            data-target-input-id="deal_id"
                                            placeholder="Saisir référence ou designation de l'affaire"
                                            :readonly="form.create_new_deal == 1 || form.create_new_deal == 2 && selectedQuote && !selectedQuote.deal"
                                        >
                                        <input type="hidden" name="deal[id]" id="deal_id" v-model="form.deal_id">
                                    </div>

                                      <hr>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="create_new_deal" id="create_new_deal_true"  value="1"  :checked="selectedQuote && !selectedQuote.deal && form.create_new_deal == 1" v-model="form.create_new_deal">
                                        <label class="form-check-label" for="create_new_deal_true">Nouvelle affaire</label>
                                    </div>

                                     <div class="form-group mt-2">
                                        <label for="deal_new_name" class="required">Nom</label>
                                        <input type="text" class="form-control" name="deal[new_name]" id="deal_new_name" :readonly="form.create_new_deal == 0 || form.create_new_deal == 2"  :required="form.create_new_deal == 1 || (selectedQuote && selectedQuote.deal)"  v-model="form.new_deal_name">
                                    </div>

                                    <hr>

                                     <div class="form-check form-check-inline" v-if="selectedQuote && !selectedQuote.study">
                                        <input class="form-check-input" type="radio" name="create_new_deal" id="create_new_deal_none" value="2" :checked="form.create_new_deal == 2" v-model="form.create_new_deal">
                                        <label class="form-check-label" for="create_new_deal_none">Ne pas affecter à une affaire</label>
                                    </div>
                                 </div>
                              
                            </div>
                            <div class="row" v-if="selectedQuote && selectedQuote.deal">
                                <div class="col-sm-12">
                                    <div class="alert alert-info">
                                        <input type="hidden" name="deal[id]" id="deal_id" v-model="form.deal_id">
                                        Le devis et la commande seront affectées à l'affaire <b>{{ selectedQuote && selectedQuote.deal ? selectedQuote.deal.number + '-' + selectedQuote.deal.name : '' }}</b>
                                    </div>
                                </div>
                            </div>


                               <div v-if="selectedQuote && selectedQuote.study">
                                    <h3 class="ix-page-title-secondary">Injection des prévisions de l'étude dans les prévisions de l'affaire</h3>
                                     <div class="form-check form-check-inline">
                                        <input class="form-check-input" required type="radio" name="inject_prediction" id="injectPredictionYes" value="1" :checked="form.inject_prediction == 1" v-model="form.inject_prediction">
                                        <label class="form-check-label" for="injectPredictionYes">Oui</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" required type="radio" name="inject_prediction" id="injectPredictionNo" value="0" :checked="form.inject_prediction == 0" v-model="form.inject_prediction">
                                        <label class="form-check-label" for="injectPredictionNo">Non</label>
                                    </div>

                                    <div class="inject-prediction-remaining mt-4" v-if="form.inject_prediction == 1">
                                        <h3 class="ix-page-title-secondary">Injection du prix de revient prévisionnel dans les restes à faires</h3>
                                        <div class="form-group">
                                            <select class="form-control" name="update_deal_remainings" id="update_deal_remainings" v-model="form.update_deal_remainings">
                                                <option value="0">Ne pas injecter</option>
                                                <option value="1" v-bind:selected="form.inject_prediction == 1">Injection synthétique</option>
                                                <option value="2">Injection détaillée</option>
                                            </select>
                                        </div>
                                    </div>

                                 </div>

                                <div class="mt-4" v-if="selectedQuote && selectedQuote.study && selectedQuote && selectedQuote.study.lots && selectedQuote && selectedQuote.study.lots.length > 0">
                                    <h3 class="ix-page-title-secondary">Voulez vous mettre les lots en production ? </h3>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" required type="radio" name="inject_lot" id="injectLotYes" value="1" :checked="form.inject_lot == 1" v-model="form.inject_lot" >
                                        <label class="form-check-label" for="injectLotYes">Oui</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" required type="radio" name="inject_lot" id="injectLotNo" value="0" :checked="form.inject_lot == 0" v-model="form.inject_lot">
                                        <label class="form-check-label" for="injectLotNo">Non</label>
                                    </div>
                                </div>
                            <br>

                            <accounting-account-generation
                            is-entreprise-input-id="is_enterprise"
                            legal-form-input-id="legal_form"
                            name-input-id="autocomplete_company_name"
                            is-supplier-input-id="is_provider"
                            state-input-id="state"
                            :auxiliaries-url="this.auxiliariesUrl"
                            :duplicate-account-setting= "this.duplicateAccountSetting"
                            :client-account-generation-setting="this.clientAccountGenerationSetting"
                            :supplier-account-generation-setting="this.supplierAccountGenerationSetting"
                            :client-account-id = "this.clientAccountId" 
                            >
                            </accounting-account-generation>
                            
                        </div>

                        <div class="modal-footer">
                            <button  type="button" class="ix-btn green" @click="post" v-bind:disabled="!checkForm() || !transform || loading">Accepter</button>
                        </div>
                    </div>
                </div>
          </div>
    </div>
</template>

<script>

import $ from "jquery";
const Swal = require('sweetalert2')
import AccountingAccountGeneration from "../crm/AccountingAccountGeneration";

export default {
    name: 'AcceptQuoteVersionning',
        props: ['quotes', 'url', 'dealUrl', 'canTransform', 'currentQuoteId', 'refuseUrl','auxiliariesUrl','duplicateAccountSetting','clientAccountGenerationSetting','supplierAccountGenerationSetting','clientAccountId'],
    components: {
        'accounting-account-generation': AccountingAccountGeneration,
    },
    data() {
        return {
            allQuotes: [],
            loading: false,
            selectedQuote: null,
            form : {
                reference: null,
                file: null,
                created_at: this.moment().format('DD/MM/YYYY') ,
                expected_at: null,
                deal_id: null,
                create_new_deal: 0,
                new_deal_name: null,
                inject_prediction: null,
                update_deal_remainings: 0,
                inject_lot: null,
            },
            transform: this.canTransform ? this.canTransform : true,
            selectedFile: {
                file: null,
            },
        }
    },
    methods: {
        /** Le total TTC d'une version, options comprises. */
        totalTtcWithOptions(quote) {
            return (parseFloat(quote.total_ttc) || 0) + (parseFloat(quote.total_optional_ttc) || 0);
        },
        /** Le total HT d'une version, options comprises, après remise globale (comme le total des options). */
        totalHtWithOptions(quote) {
            return (parseFloat(quote.total_after_discount) || 0) + (parseFloat(quote.total_optional_ht) || 0);
        },
        async openModal(){
            if(this.selectedQuote){
                 $('#acceptQuoteVersionningsModal').modal();
                if(this.selectedQuote && !this.selectedQuote.deal){
                    this.form.create_new_deal = 1;
                    this.form.new_deal_name = '';
                    this.form.deal_id = null;
                } else {
                    this.form.create_new_deal = 0;  
                    this.form.new_deal_name = this.selectedQuote.designation
                    this.form.deal_id = this.selectedQuote.deal.id
                } 
            } else {
                const { value: text } = await Swal.fire({
                    title: 'Indiquez la raison du refus',
                    input: "textarea",
                    reverseButtons: true,
                    heightAuto: false,
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Refuser',
                    showCancelButton: true
                });

                if (text) {
                    this.refuse(text);
                }
            }
            
        }, 
        handleCheckboxChange(quote) {
            this.selectedQuote = quote.accepted ? quote : null;
        },
        onFileChange(e){
            var files = e.target.files
                if (!files.length)
                    return;

            this.selectedFile.file = files[0];  
        
        },
        checkForm: function(){
            if(this.form.create_new_deal == 1)
                return this.form.new_deal_name.length > 0;

            return true;
        },
        async refuse(reason){
            fetch(this.refuseUrl , {
                    ...{
                        method: 'PUT'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                    body : JSON.stringify({
                        id: this.currentQuoteId,
                        reason : reason,
                    })
                }).then(async (response) => {
                    if(response.ok){
                        window.location.reload();
                    }

                }).catch(error => {
                    console.log(error);
                })
        },
        async post(){
            // Créer un objet FormData
            var formData = new FormData();
            formData.append('quote_id', this.selectedQuote.id);
            formData.append('state', 3);
            formData.append('create_new_deal', this.form.create_new_deal);
            formData.append('deal_new_name', this.form.new_deal_name);
            formData.append('deal_id', $('#deal_id').val());
            formData.append('file', this.selectedFile.file); // Le fichier sélectionné
            
            if (this.clientAccountGenerationSetting && (this.clientAccountId != "" || this.clientAccountId != null)) {
                formData.append('client-general', $('#client-general').val());
                formData.append('client-auxiliary', $('#client-auxiliary').val());
                formData.append('client-designation', $('#client-designation').val());         
            }

            if(this.form.created_at)
                formData.append('created_at', this.form.created_at);

            if(this.form.reference)
                formData.append('reference', this.form.reference);

            if(this.form.expected_at)
                formData.append('expected_at', this.form.expected_at);

            if(this.form.inject_lot)
                formData.append('inject_lot', this.form.inject_lot);

            if(this.form.inject_prediction)
                formData.append('inject_prediction', this.form.inject_prediction);

            if(this.form.update_deal_remainings)
                formData.append('update_deal_remainings', this.form.update_deal_remainings);    


            if(this.form.create_new_deal == 1){
                this.$swal({
                    title: 'Etes vous sûrs de vouloir créer une nouvelle affaire ?',
                    text: "Ce choix sera irréversible.",
                    icon: 'warning',
                    dangerMode : true,
                    buttons : ["Annuler" , "Oui, créer"]
                }).then((willDo) => {
                    if (willDo) {
                        this.loading = true;
                        fetch(this.url, {
                            ...{
                                    method : "POST"
                            },
                            ...this.getHttpJsonRequestHeaders(true),
                            body: formData
                        }).then((response) => {
                            if (response.status == 200) {
                                response.json().then((data) => {
                                if (data.redirect_url) {
                                   window.location.href = data.redirect_url;
                                }
                            })
                                this.loading = false;
                            }
                        }).catch((error) => {
                            console.log(error);
                            this.loading = false;
                        })
                    }
                })
            } else {
                this.loading = true;
                fetch(this.url, {
                       ...{
                            method : "POST"
                        },
                        ...this.getHttpJsonRequestHeaders(true),
                        body: formData
                }).then((response) => {
                        if (response.status == 200) {
                            response.json().then((data) => {
                            if (data.redirect_url) {
                                window.location.href = data.redirect_url;
                            }
                        })

                        this.loading = false;
                    }
                }).catch((error) => {
                    console.log(error);
                    this.loading = false;
                })
            }
        },
    },
    mounted(){
        this.loading = true;
        this.allQuotes = JSON.parse(this.quotes);

        this.allQuotes.forEach(quote => {
             quote.accepted = false;   
        });
        this.loading = false;       
    } 
}
</script>